export const TEST_AUTH_ACCOUNTS = {
	customer: {
		label: "Customer test account",
		role: "customer",
		phoneNumber: "+2347000000001",
		name: "Suleman Mualim",
		email: "suleman@proxi.test",
	},
	runner: {
		label: "Runner test account",
		role: "runner",
		phoneNumber: "+2349999999999",
		name: "Kamsy Uzoma",
		email: "kamsy.uzoma.runner@proxi.test",
		bankName: "Test Bank",
		accountNumber: "0123456789",
		accountName: "Kamsy Uzoma",
	},
} as const;

export type TestAuthAccountRole = keyof typeof TEST_AUTH_ACCOUNTS;

export type TestAuthAccount = (typeof TEST_AUTH_ACCOUNTS)[TestAuthAccountRole];

const TEST_AUTH_ACCOUNT_LIST = Object.values(TEST_AUTH_ACCOUNTS);

export const TEST_AUTH_PHONE_NUMBERS = TEST_AUTH_ACCOUNT_LIST.map(
	(account) => account.phoneNumber,
);

export const getTestAuthAccountByPhone = (
	phoneNumber: string | null | undefined,
) =>
	TEST_AUTH_ACCOUNT_LIST.find(
		(account) => account.phoneNumber === phoneNumber,
	) ?? null;

export const isTestAuthPhoneNumber = (phoneNumber: string | null | undefined) =>
	getTestAuthAccountByPhone(phoneNumber) !== null;
